import "./Home.css";
import { useCookies } from "react-cookie";
import { Switch, Route, useRouteMatch, useHistory } from "react-router-dom";
import { Row, Breadcrumbs, Spacer, Text, Button, Page } from "@geist-ui/react";
import { Redirect } from "react-router-dom";
import { MdGolfCourse } from "react-icons/md";

import QuestionsView from "./QuestionsView/QuestionsView";
import FeedView from "./FeedView/FeedView";
import Header from "./Header/Header";

function Home() {
  // eslint-disable-next-line no-unused-vars
  const [cookies, setCookie, removeCookie] = useCookies(["colabAuth"]);
  const match = useRouteMatch();
  const history = useHistory();

  const pageName = getPageName(history.location.pathname);

  if (!cookies.colabAuth) {
    return <Redirect to="/login" />;
  }

  return (
    <>
      <Header removeCookie={removeCookie} />
      <Page size="large" dotBackdrop>
        <Page.Content>
          <Row justify="space-between" align="middle">
            <Text h1 type="warning">
              {pageName}
            </Text>
            {pageName === "Top Questions" && (
              <Button
                icon={<MdGolfCourse />}
                type="secondary"
                ghost
                auto
                onClick={() => history.push("/home/feed")}
              >
                My courses
              </Button>
            )}
          </Row>
          <Spacer y={0.5} />
          <Breadcrumbs>
            <Breadcrumbs.Item href="/home">Home</Breadcrumbs.Item>
            <Breadcrumbs.Item
              href={pageName === "Top Questions" ? "Top Questions" : "My Feed"}
            >
              {pageName}
            </Breadcrumbs.Item>
          </Breadcrumbs>
          <Spacer y={1.5} />
          <Switch>
            <Route path={`${match.path}/feed`}>
              <FeedView />
            </Route>
            <Route path={`${match.path}/questions`}>
              <QuestionsView />
            </Route>
            <Route path={`${match.path}`}>
              <Redirect to={`${match.path}/questions`} />
            </Route>
          </Switch>
        </Page.Content>
      </Page>
    </>
  );
}

function getPageName(path) {
  if (path === "/home/questions") {
    return "Top Questions";
  }
  if (path === "/home/feed") {
    return "My Feed";
  }

  return "Looks like, we are lost!";
}

export default Home;
